import { render, staticRenderFns } from "./head.vue?vue&type=template&id=cbbd522e&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"
import style0 from "./head.vue?vue&type=style&index=0&id=cbbd522e&prod&scoped=true&lang=css"
import style1 from "./head.vue?vue&type=style&index=1&id=cbbd522e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbd522e",
  null
  
)

export default component.exports